// TODO refactor this using the abstract store
import { addFootnotesToStore, isNested, mountFootnotes } from '@owc-utils/Footnotes/FootnotesHelper';
import { OwcComponent } from './OwcComponent';

const addFootnotesToHTML = (component: OwcComponent) => {
  if (component.$el instanceof HTMLElement) {
    mountFootnotes(component);
  }
};

const mixin: OwcComponent = {
  created() {
    const unwatch = this.$watch(
      'isComponentDataInitialized',
      function(newValue) {
        if (newValue) {
          this.$nextTick(() => {
            // Triggering footnotes build
            if (this.componentData && this.componentData.footnotes) {
              addFootnotesToStore(this.componentData.footnotes);
            }

            if (!isNested(this)) {
              addFootnotesToHTML(this);
            }

            unwatch();
          });
        }
      },
      { deep: true },
    );
    const unwatchId = this.$watch('parentId', function(newValue) {
      this.$nextTick(() => {
        const targetWCEl = this.getHost() ?? this;
        if (isNested(targetWCEl) && newValue) {
          addFootnotesToHTML(this);
          unwatchId();
        }
      });
    });
  },
};

export default mixin;
